import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { EMPTY_STRING } from 'tbase/app.constants';
import MIME_TYPE from 'tbase/constants/ExtensionVsMIME';

var getFilesOfType = function getFilesOfType(files, mimeTypes) {
  var filesArray = Array.from(files || []);

  if (mimeTypes && mimeTypes.length && filesArray) {
    return filesArray.filter(function (file) {
      return mimeTypes.indexOf(file.type) >= 0;
    });
  }

  return filesArray || [];
};

var getFileType = function getFileType(file) {
  return file.type;
};

var getFileSize = function getFileSize(file) {
  return file.size;
};

var getFileURL = function getFileURL(file) {
  return URL.createObjectURL(file);
};
/**
 *
 * @param {Image file} file
 * Function returs a promise which always resolved with object of type {width, height}.
 * If given file is not an image, promise will be resolved with {width:0, height:0}
 */


var getImageDimensionsFromFile = function getImageDimensionsFromFile(file) {
  var imageSizePromise = new Promise(function (resolve) {
    var dimensions = {
      width: 0,
      height: 0
    };

    if (file) {
      var imgSrc = getFileURL(file);
      var img = new Image();

      img.onload = function () {
        dimensions.width = img.width;
        dimensions.height = img.height;
        resolve(dimensions);
      };

      img.onerror = function () {
        resolve(dimensions);
      };

      img.src = imgSrc;
    }
  });
  return imageSizePromise;
};

var isFileThreeSixtyImage = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(file) {
    var MIN_WIDTH, _yield$getImageDimens, width, height;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            MIN_WIDTH = 2000;
            _context.next = 3;
            return getImageDimensionsFromFile(file);

          case 3:
            _yield$getImageDimens = _context.sent;
            width = _yield$getImageDimens.width;
            height = _yield$getImageDimens.height;

            if (!(width && height && width === height * 2 && width >= MIN_WIDTH)) {
              _context.next = 8;
              break;
            }

            return _context.abrupt("return", true);

          case 8:
            return _context.abrupt("return", false);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function isFileThreeSixtyImage(_x) {
    return _ref.apply(this, arguments);
  };
}();

var getThreeSixtyAndNormalImageFiles = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(files) {
    var imageMimeTypes, videoMimeTypes, imageFiles, videoFiles, threeSixtyImageFiles, normalImageFiles, normalVideoFiles, filesWithThreeSixtyImage;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            imageMimeTypes = [MIME_TYPE.jpg, MIME_TYPE.png];
            videoMimeTypes = [MIME_TYPE.mp4, MIME_TYPE.mov, MIME_TYPE.avi, MIME_TYPE.wmv, MIME_TYPE.mpeg, MIME_TYPE.ogv, MIME_TYPE.webm, MIME_TYPE.ts];
            imageFiles = getFilesOfType(files, imageMimeTypes);
            videoFiles = getFilesOfType(files, videoMimeTypes);
            threeSixtyImageFiles = [];
            normalImageFiles = [];
            normalVideoFiles = [];
            _context2.next = 9;
            return Promise.all(imageFiles.map(isFileThreeSixtyImage));

          case 9:
            filesWithThreeSixtyImage = _context2.sent;
            imageFiles.forEach(function (file, index) {
              if (filesWithThreeSixtyImage[index]) {
                threeSixtyImageFiles.push(file);
              } else {
                normalImageFiles.push(file);
              }
            });
            videoFiles.forEach(function (file) {
              normalVideoFiles.push(file);
            });
            return _context2.abrupt("return", {
              threeSixtyImageFiles: threeSixtyImageFiles,
              normalImageFiles: normalImageFiles,
              normalVideoFiles: normalVideoFiles
            });

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getThreeSixtyAndNormalImageFiles(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

var getFileNameWithoutExtension = function getFileNameWithoutExtension(name) {
  return name && name.substring(0, name.lastIndexOf('.'));
};

var getFileExtension = function getFileExtension(name) {
  var ext = EMPTY_STRING;

  if (name) {
    ext = name.split('.').pop();
    if (ext === name) return ext;
  }

  return ext;
};

export default {
  getFilesOfType: getFilesOfType,
  getFileType: getFileType,
  getFileSize: getFileSize,
  getImageDimensionsFromFile: getImageDimensionsFromFile,
  getFileURL: getFileURL,
  isFileThreeSixtyImage: isFileThreeSixtyImage,
  getThreeSixtyAndNormalImageFiles: getThreeSixtyAndNormalImageFiles,
  getFileNameWithoutExtension: getFileNameWithoutExtension,
  getFileExtension: getFileExtension
};